module.exports = __webpack_public_path__ + "img/617.b1b06ab1.jpg";